export const last = <T>(arr: T[]): T | undefined => arr[arr.length - 1]
export const optLast = <T>(arr: T[] | undefined): T | undefined =>
  arr?.[arr.length - 1]

export const findLastIndex = <T>(
  arr: T[],
  predicate: (v: T) => boolean
): number => {
  let i = arr.length - 1
  while (i >= 0) {
    const v = arr[i]
    if (v && predicate(v)) {
      return i
    }
    i--
  }
  return -1
}
